import { render, staticRenderFns } from "./MergedLetters.vue?vue&type=template&id=d6521036&"
import script from "./MergedLetters.vue?vue&type=script&lang=js&"
export * from "./MergedLetters.vue?vue&type=script&lang=js&"
import style0 from "./MergedLetters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports